<template>
  <div class="wrapper">
    <h3 style="font-size: 20px; font-weight: 500;">{{ $t('upload_warrant') }}</h3>
    <p>{{ $t('warrant_is_needed_as_pdf') }}</p>
    <v-form @submit.prevent="onSubmit">
      <v-layout class="form-wrapper" justify-center wrap>
        <v-flex v-for="file in selectedFiles" :key="file.name" class="text-xs-center" xs12>
          <strong>{{ file.name }}</strong>
        </v-flex>
        <v-btn color="primary" class="primary-btn" @click="selectFiles">{{ $t('choose_pdf_file') }}</v-btn>
      </v-layout>
      <input
        ref="fileInput"
        :accept="allowedFileFormats"
        type="file"
        @change="onFileChange">
      <v-btn
        v-if="selectedFiles.length"
        type="submit"
        color="primary"
        class="primary-btn">
        {{ $t('confirm') }}
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'WarrantUploadForm',

  data() {
    return {
      allowedFileFormats: 'application/pdf',
    };
  },

  computed: {
    ...mapState({
      selectedFiles: state => state.documents.selectedFiles,
    }),
  },

  methods: {
    ...mapMutations({
      setSelectedFiles: 'documents/setFiles',
    }),

    onSubmit() {
      this.$router.push({ name: 'agreements' });
    },

    selectFiles() {
      this.$refs.fileInput.click();
    },

    onFileChange(event) {
      let files;
      if (event && event.target) {
        files = event.target.files || event.dataTransfer.files;
      } else if (event) {
        files = [event];
      }
      this.setSelectedFiles(files);
    },
  },
};
</script>

<style scoped>
  input[type=file] {
    display: none;
  }
</style>
